import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=e1039c5c&scoped=true"
import script from "./ModuleSettings.vue?vue&type=script&lang=js"
export * from "./ModuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=e1039c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1039c5c",
  null
  
)

export default component.exports